import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onUninstallMetaOsApp = action("UninstallMetaOsApp", event => ({
    owaType: "uninstall",
    event,
})) as OwaNovaActionUnion<"uninstall">;
